import React from "react";

import { View, StyleSheet, Platform } from "react-native";
import { Icon, ImgIcon } from "components";

import { icons } from "assets/icons";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import { colors } from "assets/constants";

export default function ChatTicks(props: { received?: boolean }) {
  const {
    company: { color },
  } = useRecoilValue(authAtom);

  return (
    <View style={styles.container}>
      {props.received ? (
        <>
          <ImgIcon size={12} color={color} icon={icons.check} />
          <ImgIcon
            size={12}
            color={color}
            icon={icons.check}
            style={Platform.OS === "web" ? { left: 6 } : { right: 6 }}
          />
        </>
      ) : (
        <Icon
          type="ion"
          name="timer-outline"
          size={14}
          color={colors.textColorDefault}
        />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row-reverse",

    width: 30,
    ...(Platform.OS === "web" ? { paddingRight: 5 } : { paddingLeft: 5 }),
  },
});
